import { NavBar } from '../../../../themes/components/Navbar';
import { Sidebar } from '../../../../themes/components/Sidebar';
import { Toaster } from 'react-hot-toast';
import { FormularioNovoCliente } from '../../components/FormularioNovoCliente';
import { FooterMenuNovoCliente } from '../../components/FooterMenuNovoCliente';
import { useEffect, useState } from 'react';
import { contatoNovoCliente, InterfaceNovoCliente, referenciaNovoCliente } from '../../interfaces';
import { useModals } from '../../../../contexts/Modals';
import { Typography } from '@material-ui/core';
import { Button } from '../../../../themes/components/Button';
import { useClientes } from '../../../../contexts/Clientes';
import { useHistory } from 'react-router-dom';
import { getFromSessionStorage, saveInSessionStorage } from '../../../../contexts/LocalStorage';

export const NovoCliente = () => {
    const history = useHistory();
    const { mostrarInfoOK, setShowModalInfo, setMensagem, mostrarModalProgress } = useModals();
    const { cadastrarNovoCliente } = useClientes();
    const labelCampos = {
        "nome": "Razão Social",
        "fantasia": "Nome Fantasia",
        "cpfcnpj": "CPF/CNPJ",
        "tipocliente": "Tipo Cliente",
        "ramoatividade": "Ramo de Atividade",
        "segmento": "Segmento",
        "email": "Email",
        "telefone1": "Telefone 1",
        "telefone2": "Telefone 2",
        "insestadual": "Inscrição Estadual",
        "condicaopagamento": "Condição de Pagamento",
        "sugestaolimite": "Sugestão de Limite",
        "endereco": "Endereço",
        "numeroendereco": "Número do Endereço",
        "complementoendereco": "Complemento do Endereço",
        "bairroendereco": "Bairro",
        "cidadeendereco": "Cidade",
        "ufendereco": "Estado",
        "cependereco": "CEP",
        "observacao": "Observação/Parecer Financeiro",
        "temenderecocob": "Campos de cobrança",
        "enderecocobranca": "Endereço de Cobrança",
        "numerocobranca": "Número de Cobrança",
        "complentocobranca": "Complemento de Cobrança",
        "bairrocobranca": "Bairro de Cobrança",
        "cidadecobranca": "Cidade de Cobrança",
        "ufcobranca": "Estado de Cobrança",
        "cepcobranca": "CEP de cobrança",
        "contatos": [
            {
                "nome": "Nome do Contato",
                "email": "Email de Contato",
                "telefone": "Telefone de Contato",
                "aniversario": "Data de Aniversário",
                "tipo": "Tipo de Contato"
            }
        ],
        "referencias": [{
            "nome": "Nome da Referência",
            "telefone": "Telefone da Referência",
            "cpfcnpj": "CPF/CNPJ da Referência"
        }]
    }
    /*
    const [novoCliente, setNovoCliente] = useState<InterfaceNovoCliente>(getFromSessionStorage("novocliente") !== null ? (JSON.parse(String(getFromSessionStorage("novocliente"))) as InterfaceNovoCliente) : {
        "nome": "Sarah Eloá Assis",
        "fantasia": "Sarah Eloá Assis",
        "cpfcnpj": "03729185730",
        "tipocliente": "J",
        "ramoatividade": "1",
        "email": "sarah_eloa@terra.com.br",
        "telefone1": "79998194487",
        "telefone2": "79998194487",
        "insestadual": "isento",
        "condicaopagamento": "",
        "sugestaolimite": "",
        "endereco": "Rua L",
        "numeroendereco": "987",
        "complementoendereco": "",
        "bairroendereco": "São Conrado",
        "cidadeendereco": "Aracaju",
        "ufendereco": "PE",
        "observacao": "Cliente muito pagador e pode comprar a vontade",
        "cependereco": "49043343",
        "temenderecocob": "N",
        "enderecocobranca": "Rua L",
        "numerocobranca": "987",
        "complentocobranca": "",
        "bairrocobranca": "São Conrado",
        "cidadecobranca": "Aracaju",
        "ufcobranca": "SE",
        "cepcobranca": "49043343",
        "contatos": [
            {
                "nome": "",
                "email": "",
                "telefone": "",
                "aniversario": "",
                "tipo": "C"
            }
        ],
        "referencias": [{
            "nome": "",
            "telefone": "",
            "cpfcnpj": ""
        }]
    })
    const [contatos, setContatos] = useState<contatoNovoCliente[]>(getFromSessionStorage("contatoscliente") !== null ? (JSON.parse(String(getFromSessionStorage("contatoscliente"))) as contatoNovoCliente[]) : [{
        "nome": "Sarah Eloá",
        "email": "sarah_eloa@terra.com.br",
        "telefone": "79998194487",
        "aniversario": "12/06/1989",
        "tipo": "C"
    },
    {
        "nome": "Sarah Eloá",
        "email": "sarah_eloa@terra.com.br",
        "telefone": "79998194487",
        "aniversario": "12/06/1989",
        "tipo": "C"
    }])
    const [referencias, setReferencias] = useState<referenciaNovoCliente[]>(getFromSessionStorage("referenciascliente") !== null ? (JSON.parse(String(getFromSessionStorage("referenciascliente"))) as referenciaNovoCliente[]) : [{
        "nome": "Sarah Eloá",
        "telefone": "79998194487",
        "cpfcnpj": "20365604000149"
    },
    {
        "nome": "Sarah Eloá",
        "telefone": "79998194487",
        "cpfcnpj": "20365604000149"
    },
    {
        "nome": "Sarah Eloá",
        "telefone": "79998194487",
        "cpfcnpj": "20365604000149"
    }])
    */
    const [novoCliente, setNovoCliente] = useState<InterfaceNovoCliente>(getFromSessionStorage("novocliente") !== null ? (JSON.parse(String(getFromSessionStorage("novocliente"))) as InterfaceNovoCliente) : {
        "nome": "",
        "fantasia": "",
        "cpfcnpj": "",
        "tipocliente": "J",
        "ramoatividade": undefined,
        "segmento": undefined,
        "grupo": "",
        "email": "",
        "telefone1": "",
        "telefone2": "",
        "insestadual": "",
        "condicaopagamento": undefined,
        "sugestaolimite": "",
        "endereco": "",
        "numeroendereco": "",
        "complementoendereco": "",
        "bairroendereco": "",
        "cidadeendereco": "",
        "ufendereco": "PE",
        "observacao": "",
        "cependereco": "",
        "temenderecocob": "N",
        "enderecocobranca": "",
        "numerocobranca": "",
        "complentocobranca": "",
        "bairrocobranca": "",
        "cidadecobranca": "",
        "ufcobranca": "",
        "cepcobranca": "",
        "contatos": [
            {
                "nome": "",
                "email": "",
                "telefone": "",
                "aniversario": "",
                "tipo": "C"
            }
        ],
        "referencias": [{
            "nome": "",
            "telefone": "",
            "cpfcnpj": ""
        }]
    });
    const [contatos, setContatos] = useState<contatoNovoCliente[]>(getFromSessionStorage("contatoscliente") !== null ? (JSON.parse(String(getFromSessionStorage("contatoscliente"))) as contatoNovoCliente[]) : [{
        "nome": "",
        "email": "",
        "telefone": "",
        "aniversario": "",
        "tipo": "C"
    },
    {
        "nome": "",
        "email": "",
        "telefone": "",
        "aniversario": "",
        "tipo": "C"
    }]);
    const [referencias, setReferencias] = useState<referenciaNovoCliente[]>(getFromSessionStorage("referenciascliente") !== null ? (JSON.parse(String(getFromSessionStorage("referenciascliente"))) as referenciaNovoCliente[]) : [{
        "nome": "",
        "telefone": "",
        "cpfcnpj": ""
    },
    {
        "nome": "",
        "telefone": "",
        "cpfcnpj": ""
    },
    {
        "nome": "",
        "telefone": "",
        "cpfcnpj": ""
    }]);


    const [loadingSalvandoCliente, setLoadingSalvandoCliente] = useState<boolean>(false);

    function handleChangeCliente(event: React.ChangeEvent<any> | { target: { name: string, value: string | undefined } }) {
        const { value, name } = event.target;
        if (value !== undefined) {
            setNovoCliente({
                ...novoCliente,
                [name]: value.replace("&", "e")
            });
            saveInSessionStorage("novocliente", JSON.stringify({
                ...novoCliente,
                [name]: value.replace("&", "e")
            }));
        }
    }

    function handleChangeContatos(event: React.ChangeEvent<any> | { target: { name: string, value: string } }, index: number) {
        const { value, name } = event.target;
        let tempContatos: any = [...contatos]
        tempContatos[index][name] = value;
        setContatos(tempContatos);
        saveInSessionStorage("contatoscliente", JSON.stringify(tempContatos))
    }

    function handleChangeReferencias(event: React.ChangeEvent<any> | { target: { name: string, value: string } }, index: number) {
        const { value, name } = event.target;
        let tempReferencias: any = [...referencias]
        tempReferencias[index][name] = value.replace("&", "e");
        setReferencias(tempReferencias);
        saveInSessionStorage("referenciascliente", JSON.stringify(tempReferencias))
    }

    function changeNovoCliente(nvCliente: InterfaceNovoCliente) {
        setNovoCliente(nvCliente);
    }

    function confirmaAprovacao() {
        setMensagem(
            <div className='menssage-order-list-new-client'>
                <Typography>{`Será necessário enviar os seguintes documentos do cliente:`}</Typography>
                <br />
                <ol>
                    <li><Typography>{`Contrato Social`}</Typography></li>
                    <li><Typography>{`Notas Fiscais das Referências`}</Typography></li>
                </ol>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button onClick={() => [setShowModalInfo(false), registrarAprovacao()]} classBtn={"btn-notifications color-default"}>Continuar</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    function registrarAprovacao() {
        //Montando objeto de novo cliente com os contatos e referencias
        let tempNovoCliente = novoCliente;
        tempNovoCliente.contatos = contatos;
        tempNovoCliente.referencias = referencias;

        setLoadingSalvandoCliente(true);
        //Enviando novo cliente para o ERP
        cadastrarNovoCliente(tempNovoCliente, history)
            .then(res => {
                setLoadingSalvandoCliente(false);
                resetCampos();
                mostrarInfoOK("Cliente Cadastrado com Sucesso!", "Código do novo cliente: " + res.codcli);
            })
            .catch(err => {
                console.log("err retorno cliente");
                console.log(err);
                if (err.error !== undefined && err.error.message !== undefined) {
                    mostrarInfoOK("Erro ao cadastrar cliente!", err.error.message);
                } else {
                    mostrarInfoOK("Erro ao cadastrar cliente!", err.message !== undefined ? err.message : err);
                }
                setLoadingSalvandoCliente(false);
            })
    }

    function salvarNovoCliente() {

        if (validacaoCamposCliente()) {
            confirmaAprovacao();
        }
    }

    function validacaoCamposCliente() {
        for (let index = 0; index < Object.keys(novoCliente).length; index++) {
            const property = Object.keys(novoCliente)[index];
            if (property === "temenderecocob" && (novoCliente as any)[property] === 'N') {
                break;
            }
            if (property !== "grupo" && property !== "complementoendereco" && property !== "complentocobranca" && (novoCliente as any)[property] === '') {
                mostrarInfoOK(`Verifique o campo ${(labelCampos as any)[property]}`, "Valor inválido!");
                return false;
            }
        }
        for (let cont = 0; cont < contatos.length; cont++) {
            const element = contatos[cont];
            for (let index = 0; index < Object.keys(element).length; index++) {
                const property = Object.keys(element)[index];
                if (property !== "aniversario" && (element as any)[property] === '') {
                    mostrarInfoOK(`Verifique o campo ${(labelCampos.contatos as any)[0][property]}`, "Valor inválido!");
                    return false;
                }
            }
        }

        for (let cont = 0; cont < referencias.length; cont++) {
            const element = referencias[cont];
            for (let index = 0; index < Object.keys(element).length; index++) {
                const property = Object.keys(element)[index];
                if (property !== "telefone" && property !== "cpfcnpj" && (element as any)[property] === '') {
                    mostrarInfoOK(`Verifique o campo ${(labelCampos.referencias as any)[0][property]}`, "Valor inválido!");
                    return false;
                }
            }
        }
        return true;
    }

    useEffect(() => {
        if (loadingSalvandoCliente)
            mostrarModalProgress("Salvando cliente")
    }, [loadingSalvandoCliente])

    function resetCampos() {
        sessionStorage.removeItem("tempRamo");
        sessionStorage.removeItem("tempSegmento");
        sessionStorage.removeItem("tempCond");
        sessionStorage.removeItem("referenciascliente");
        sessionStorage.removeItem("contatoscliente");
        sessionStorage.removeItem("novocliente");
        setNovoCliente({
            "nome": "",
            "fantasia": "",
            "cpfcnpj": "",
            "tipocliente": "J",
            "ramoatividade": undefined,
            "segmento": undefined,
            "grupo":"",
            "email": "",
            "telefone1": "",
            "telefone2": "",
            "insestadual": "",
            "condicaopagamento": undefined,
            "sugestaolimite": "",
            "endereco": "",
            "numeroendereco": "",
            "complementoendereco": "",
            "bairroendereco": "",
            "cidadeendereco": "",
            "ufendereco": "PE",
            "cependereco": "",
            "observacao": "",
            "temenderecocob": "N",
            "enderecocobranca": "",
            "numerocobranca": "",
            "complentocobranca": "",
            "bairrocobranca": "",
            "cidadecobranca": "",
            "ufcobranca": "",
            "cepcobranca": "",
            "contatos": [
                {
                    "nome": "",
                    "email": "",
                    "telefone": "",
                    "aniversario": "",
                    "tipo": "C"
                }
            ],
            "referencias": [{
                "nome": "",
                "telefone": "",
                "cpfcnpj": ""
            }]
        });
        setContatos([{
            "nome": "",
            "email": "",
            "telefone": "",
            "aniversario": "",
            "tipo": "C"
        },
        {
            "nome": "",
            "email": "",
            "telefone": "",
            "aniversario": "",
            "tipo": "C"
        }]);
        setReferencias([{
            "nome": "",
            "telefone": "",
            "cpfcnpj": ""
        },
        {
            "nome": "",
            "telefone": "",
            "cpfcnpj": ""
        },
        {
            "nome": "",
            "telefone": "",
            "cpfcnpj": ""
        }]);
    }

    function confirmaResetCampos() {
        setMensagem(
            <div className='mensagem-info-modal-loading'>
                <Typography>{`Deseja cancelar o cadastro do Novo Cliente?`}</Typography>
                <Typography>{`Todas as informações serão perdidas!`}</Typography>
                <div style={{ display: 'flex' }}>
                    <Button onClick={() => setShowModalInfo(false)} classBtn={"btn-notifications color-default"}>Cancelar</Button>
                    <Button onClick={() => [setShowModalInfo(false), resetCampos()]} classBtn={"btn-notifications color-red"}>Sim</Button>
                </div>
            </div>);
        setShowModalInfo(true);
    }

    return (
        <div className="site">
            <Sidebar />
            <div className="main-content">
                <div>
                    <NavBar />
                    <div className="main-content-novo-cliente">
                        <FormularioNovoCliente
                            handleChangeCliente={handleChangeCliente}
                            handleChangeContatos={handleChangeContatos}
                            novoCliente={novoCliente}
                            setNovoCliente={setNovoCliente}
                            changeNovoCliente={changeNovoCliente}
                            contatos={contatos}
                            setContatos={setContatos}
                            referencias={referencias}
                            setReferencias={setReferencias}
                            handleChangeReferencias={handleChangeReferencias}
                        />
                    </div>
                </div>
                <FooterMenuNovoCliente
                    regraSalvar={true}
                    regraCancelar={true}
                    funcSalvar={() => salvarNovoCliente()}
                    funcCancelar={() => { confirmaResetCampos() }}
                />
            </div>
            <Toaster />
        </div>
    )
}